import { addNavMenuItem,Permission } from "@bb-vendure/admin-ui/core";

export default [
  addNavMenuItem(
    {
      id: "history-entry",
      label: "nav.history-logs",
      routerLink: ["/extensions/history"],
      icon: "history",
      requiresPermission : userPermission => userPermission.includes(Permission.SuperAdmin)
    },
    "system"
  ),
];
